import { TkSearchFormListItem } from "../../../type/componentsType/TkSearchForm";

const getListData = (year: any): TkSearchFormListItem[] => {
  let selectList = [];
  for (let i = 2024; i <= year; i++) {
    selectList.push({ value: `${i}`, label: `${i}年度` });
  }

  let listData: TkSearchFormListItem[] = [
    {
      label: "年度",
      keyword: "year",
      type: "selectFrom",
      selectPropsList: selectList,
    },
  ];

  return listData;
};

export { getListData };
